import React, {useState, useEffect} from "react";
import {IoAddCircleOutline} from "react-icons/io5";
import ModalAddAdditionalSpecification from "../../components/inserts/ModalAddAdditionalSpecification";
import Select from "../../components/Select";
import {action, createItem, deleteItem} from "../../services/service";
import {useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import DeleteButton from "../../components/DeleteButton";
import Pagination from "../../components/Pagination";
import swal from "sweetalert";
import {useTranslation} from "react-i18next";
import {toast} from "react-toastify";
import TemDataTableInline from "../../components/TemDataTableInline";
import EditButton from "../../components/EditButton";
import CopyButton from "../../components/CopyButton";

const headerTable = [{
    name: "id", sort: false
}, {
    name: "color", sort: true
}, {
    name: "article", sort: true
}, {
    name: "product_name", sort: true
}, {
    name: "supplier_name", sort: true
}, <span className="sr-only">Edit</span>,];

const bodyTable = [
    "id",
    "color",
    "article",
    "productName",
    "supplierName",
    "actions",
];

const InsertsSpecification = ({
                                  additionalId,
                                  setSpecificationRowId,
                              }) => {
    const navigate = useNavigate();
    const {token} = useSelector((state) => state.user);
    const [itemsPerPage, setItemsPerPage] = useState(5);
    const [itemOffset, setItemOffset] = useState(0);
    const [forcePage, setForcePage] = useState(0);
    const [data, setData] = useState({
        data: [],
        recordsTotal: 0,
        pageCount: 1,
    });
    const [open, setOpen] = useState(false);
    const [sortColumn, setSortColumn] = useState("id");
    const [sortDir, setSortDir] = useState("DESC");
    const [clear, setClear] = useState(false);
    const {t} = useTranslation();
    const [isEdit, setIsEdit] = useState(false);
    const [spesificationId, setSpesificationId] = useState(null);

    const fetchData = async () => {
        const response = await createItem(
            `${process.env.REACT_APP_HOST_BASE_URL}/v1/additional/specification/table`,
            token,
            {
                draw: 1,
                start: itemOffset,
                length: itemsPerPage,
                recordsTotal: 0,
                columns: [],
                order: [{column: sortColumn, dir: sortDir}],
                search: {value: "", regex: true},
                filter: {additionalId: additionalId},
            }
        );
        if (response.success) {
            setClear(false);
            let reviewData = response.data.data.map((item, index) => {
                return {
                    id: item.id,
                    supplierName: item.supplierName,
                    article: item?.article,
                    productName: item.productName,
                    color: item?.textureName,
                    actions: (
                        <div className="flex justify-end mt-3 sm:mt-0 sm:ml-4">
                            <CopyButton onclick={() => onCopyRow(item.id)}/>
                            <EditButton onclick={() => editHandler(item.id)}/>
                            <DeleteButton onclick={() => handleDelete(item.id)}/>
                        </div>
                    ),
                };
            });
            setData({
                data: reviewData,
                recordsTotal: response.data.recordsFiltered,
                pageCount: Math.ceil(
                    response.data.recordsFiltered / parseInt(itemsPerPage)
                ),
            });
        } else {
            navigate("/error", {
                state: {
                    status: response.status,
                    message: response.message ? response.message : null,
                },
            });
        }
    };

    useEffect(() => {
        if (clear) {
            fetchData();
        }
    }, [clear]);

    useEffect(() => {
        if (additionalId) {
            fetchData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [additionalId, itemOffset, itemsPerPage, data.recordsTotal]);

    const handlePageClick = (event) => {
        setForcePage(event.selected);
        const newOffset =
            (event.selected * parseInt(itemsPerPage)) % data.recordsTotal;
        setItemOffset(newOffset);
    };

    const sortFunction = (value) => {
        setSortColumn(value.field ? value.field : "id");
        setSortDir(value.sort === true ? 'ASC' : 'DESC');
        setClear(true);
    }

    const handleDelete = async (id) => {
        const responseReceived = await swal({
            title: t(`action.delete_item.title`),
            text: t(`action.delete_item.text`),
            icon: "warning",
            buttons: {
                cancel: true,
                confirm: true,
            },
        });
        if (responseReceived) {
            const response = await deleteItem(
                `${process.env.REACT_APP_HOST_BASE_URL}/v1/additional/specification/${id}`,
                token
            );
            if (response.success) {
                fetchData();
                toast.success(t('action.delete_success'), {
                    position: "bottom-right",
                    autoClose: 3000,
                    closeOnClick: true,
                    className: "add-success"
                });
            } else {
                navigate("/error", {
                    state: {
                        status: response.status,
                        message: response.message ? response.message : null,
                    },
                });
            }
        } else {
            return;
        }
    };
    const onCopyRow = async (id) => {
        const responseReceived = await swal({
            title: t(`action.copy_item.title`),
            text: t(`action.copy_item.text`),
            icon: "warning",
            buttons: {
                cancel: true,
                confirm: true,
            },
        });
        if (responseReceived) {
            let url = `${process.env.REACT_APP_HOST_BASE_URL}/v1/additional/specification/copy/${id}`;
            let res = await action(url, "POST", token);
            if (res.success) {
                fetchData();

            } else {
                navigate("/error", {
                    state: {
                        status: res.status,
                        message: res.message ? res.message : null,
                    },
                });
            }
        }
    };
    const handleOpen = () => {
        setOpen(true);
        setSpesificationId(null)
    }
    const handleClose = ()=> {
        setOpen(false);
        setIsEdit(false);
        setSpesificationId(null);
    }
    const editHandler = async (id) => {
        setIsEdit(true)
        setSpesificationId(id)
        setOpen(true)
    }

    return (
        <>
            <ModalAddAdditionalSpecification
                open={open}
                handleClose={handleClose}
                additionalId={additionalId}
                id={spesificationId}
                fetchData_={fetchData}
                isEdit={isEdit}
            />
            <div className="sm:flex-auto">
                <h1 className="text-xl font-semibold text-gray-900">
                    {t(`table.insert.insert_specification`)}
                </h1>
            </div>
            <div className="flex items-center justify-between">
                <Select setItemsPerPage={setItemsPerPage} itemsPerPage={itemsPerPage}/>
                <button
                    className={`${
                        additionalId
                            ? "flex items-center px-3 py-1 text-sm font-medium leading-4 text-white bg-indigo-600 border border-transparent rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                            : "cursor-no-drop flex items-center px-3 py-1 text-sm font-medium leading-4 text-white bg-indigo-300 border border-transparent rounded-md shadow-sm "
                    }   `}
                    onClick={handleOpen}
                    disabled={additionalId ? false : true}
                >
                    {t('action.add')} {additionalId}
                    <IoAddCircleOutline className="w-4 h-4 ml-1"/>
                </button>
            </div>
            <TemDataTableInline
                data={data.data}
                bodyContent={bodyTable}
                headerTable={headerTable}
                rowHandler={(id) => setSpecificationRowId(id)}
                sortFunction={sortFunction}
            />
            <Pagination
                handlePageClick={handlePageClick}
                pageCount={data.pageCount}
                forcePage={forcePage}
            />
        </>
    );
};

export default InsertsSpecification;
